import React from "react";

import { Navigate, Route, Routes } from "react-router-dom";

import ROUTES from "@app/common/routes";

import AccountSettings from "./AccountSettings";
import Billing from "./Billing";
import UserPreferences from "./UserPreferences";
import WorkspaceRoutes from "./WorkspaceSettings";
import WorkspaceSettingsRedirect from "./WorkspaceSettings/WorkspaceSettingsRedirect";

const SettingsRoutes = () => {
  return (
    <Routes>
      {/* TODO: move billing out of the settings routes */}
      <Route path="billing/*" element={<Billing />} />

      {/* TODO: remove the AccountSettings component since all it's really doing is adding the action bar/title */}
      <Route element={<AccountSettings />}>
        <Route path="workspace/*" element={<WorkspaceSettingsRedirect />}>
          <Route path="*" element={<WorkspaceRoutes />} />
        </Route>
      </Route>
      <Route path="user/*" element={<UserPreferences />} />
      {/* Redirects users that try to hit a (deprecated) /analytics/settings/:section route*/}
      <Route
        path="*"
        element={<Navigate to={ROUTES.SETTINGS_DEFAULT_SECTION} />}
      />
    </Routes>
  );
};

export default SettingsRoutes;
